"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var adaptiveCards = _interopRequireWildcard(require("adaptivecards"));

var _botframeworkWebchatComponent = _interopRequireWildcard(require("botframework-webchat-component"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _createAdaptiveCardMiddleware = _interopRequireDefault(require("./adaptiveCards/createAdaptiveCardMiddleware"));

var _createStyleSetWithAdaptiveCards = _interopRequireDefault(require("./adaptiveCards/Styles/createStyleSetWithAdaptiveCards"));

var _adaptiveCardHostConfig = _interopRequireDefault(require("./adaptiveCards/Styles/adaptiveCardHostConfig"));

var _renderMarkdown = _interopRequireDefault(require("./renderMarkdown")); // Add additional props to <WebChat>, so it support additional features


var FullReactWebChat =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(FullReactWebChat, _React$Component);

  function FullReactWebChat(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FullReactWebChat);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FullReactWebChat).call(this, props));
    _this.createAttachmentMiddleware = (0, _memoizeOne.default)(function (adaptiveCardHostConfig, middlewareFromProps, styleOptions, renderMarkdown) {
      return (0, _botframeworkWebchatComponent.concatMiddleware)(middlewareFromProps, (0, _createAdaptiveCardMiddleware.default)({
        adaptiveCardHostConfig: adaptiveCardHostConfig || (0, _adaptiveCardHostConfig.default)(styleOptions),
        adaptiveCards: adaptiveCards,
        renderMarkdown: renderMarkdown
      }));
    });
    _this.memoizeStyleSet = (0, _memoizeOne.default)(function (styleSet, styleOptions) {
      return styleSet || (0, _createStyleSetWithAdaptiveCards.default)(styleOptions);
    });
    _this.memoizeRenderMarkdown = (0, _memoizeOne.default)(function (renderMarkdown, _ref) {
      var options = _ref.options;
      return function (markdown) {
        return renderMarkdown(markdown, options);
      };
    });
    return _this;
  }

  (0, _createClass2.default)(FullReactWebChat, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          adaptiveCardHostConfig = _this$props.adaptiveCardHostConfig,
          attachmentMiddleware = _this$props.attachmentMiddleware,
          renderMarkdown = _this$props.renderMarkdown,
          styleOptions = _this$props.styleOptions,
          styleSet = _this$props.styleSet,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["adaptiveCardHostConfig", "attachmentMiddleware", "renderMarkdown", "styleOptions", "styleSet"]);
      var memoizedStyleSet = this.memoizeStyleSet(styleSet, styleOptions);
      var memoizedRenderMarkdown = renderMarkdown || this.memoizeRenderMarkdown(_renderMarkdown.default, memoizedStyleSet);
      return _react.default.createElement(_botframeworkWebchatComponent.default, (0, _extends2.default)({
        attachmentMiddleware: this.createAttachmentMiddleware(adaptiveCardHostConfig, attachmentMiddleware, styleOptions, memoizedRenderMarkdown),
        renderMarkdown: memoizedRenderMarkdown,
        styleOptions: styleOptions,
        styleSet: memoizedStyleSet
      }, otherProps));
    }
  }]);
  return FullReactWebChat;
}(_react.default.Component);

FullReactWebChat.defaultProps = {
  adaptiveCardHostConfig: undefined,
  attachmentMiddleware: undefined,
  renderMarkdown: undefined,
  styleOptions: undefined,
  styleSet: undefined
};
FullReactWebChat.propTypes = {
  adaptiveCardHostConfig: _propTypes.default.any,
  attachmentMiddleware: _propTypes.default.func,
  renderMarkdown: _propTypes.default.func,
  styleOptions: _propTypes.default.any,
  styleSet: _propTypes.default.any
};
var _default = FullReactWebChat;
exports.default = _default;